<template>
  <div class="modal fade" tabindex="-1" :id="id" data-bs-backdrop="false" aria-labelledby="pwaInstallModalLabel"
    aria-hidden="true">
    <div class="custom-backdrop" @click="handleClose"></div>
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content border shadow-lg">
        <div class="modal-header">
          <h2 class="h2 mb-0">Instalar Greezon</h2>
          <i type="button" class="fas fa-times text-muted" data-bs-dismiss="modal" aria-label="Close" @click="handleClose"></i>
        </div>
        <div class="modal-body border-0">
          <p class="mb-3">Para instalar o Greezon na tela inicial do seu iPhone/iPad:</p>
          <ol class="install-steps">
            <li class="mb-3">
              <i class="fas fa-share fs-5 me-2"></i>
              Toque no ícone de <strong>compartilhar</strong> (quadrado com seta para cima) na barra inferior do Safari
            </li>
            <li class="mb-3">
              <i class="fas fa-plus-square fs-5 me-2"></i>
              Role para baixo e toque em <strong>"Adicionar à Tela de Início"</strong>
            </li>
            <li>
              <i class="fas fa-check-circle fs-5 me-2"></i>
              Toque em <strong>"Adicionar"</strong> no canto superior direito
            </li>
          </ol>
          <p class="text-muted mt-3 mb-0">
            <small>Após instalado, você poderá abrir o Greezon diretamente da tela inicial como um aplicativo.</small>
          </p>
        </div>
        <div class="modal-footer">
          <button @click="handleClose" class="btn btn-dark btn-sm" data-bs-dismiss="modal">Entendi</button>
        </div>
      </div>
    </div>
  </div>
  <button hidden :id="`trigger-${id}-btn`" type="button" data-bs-toggle="modal" :data-bs-target="`#${id}`"></button>
</template>

<script lang="ts" setup>
import { EModal } from '@/enums';
import useModals from './useModals';

const id = EModal.pwa_install;
const { toggleModal } = useModals();

const handleClose = () => {
  toggleModal(id);
};
</script>

<style scoped>
.install-steps {
  padding-left: 1.5rem;
}

.install-steps li {
  line-height: 1.6;
}

.install-steps i {
  color: var(--bs-primary);
}
</style>

<style>
/* Backdrop customizado - não usa backdrop do Bootstrap */
#pwa-install-modal .custom-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1;
  opacity: 0;
  transition: opacity 0.15s linear;
}

#pwa-install-modal.show .custom-backdrop {
  opacity: 1;
}

/* Modal principal */
#pwa-install-modal {
  z-index: 99999 !important;
}

#pwa-install-modal .modal-dialog {
  z-index: 100000 !important;
  position: relative;
}

/* Sombra extra para destacar */
#pwa-install-modal .modal-content {
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.5) !important;
}

/* iOS Safari específico */
@supports (-webkit-touch-callout: none) {
  #pwa-install-modal {
    position: fixed !important;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  #pwa-install-modal .modal-dialog {
    position: fixed !important;
    top: 50% !important;
    left: 50% !important;
    transform: translate(-50%, -50%) !important;
    margin: 0 !important;
    width: 90%;
    max-width: 500px;
  }

  #pwa-install-modal .custom-backdrop {
    -webkit-tap-highlight-color: transparent;
  }
}
</style>
